import React, { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import axios from 'utils/axios';
import { Container } from 'components';
import {
  Header, HeaderTitle, HeaderDescription,
  Wrapper, Section, Title, Content, ShopItem, ShopItemHeader,
  ShopItemCell, ShopItemBody, SectionContent, Radio, Item,
} from './style';

interface Props {
  locaiton: any,
  history: any,
  match: any,
}

const PayComplete: React.FC<Props> = props => {
  const [manager, setManager] = useState<string>('-');
  const [shopItem, setShopItem] = useState<string>('-');
  const [price, setPrice] = useState<number>(0);
  const [name, setName] = useState<string>('-');
  const [email, setEmail] = useState<string>('-');
  const [phone, setPhone] = useState<string>('-');
  const [payMethod] = useState<string>('card');

  useEffect(() => {
    const uid = props.match.params.uid;
    if (!uid) {
      alert('올바른 결제정보가 아닙니다. 다시 확인해주세요.');
      props.history.push('/');
    } else {
      axios.get(`/ceo/payment/${uid}/`)
        .then((res: AxiosResponse) => {
          const data = res.data;
          setShopItem(data.ceo_shop_item_title);
          setPrice(data.price);
          setManager(data.salesman_name);
          setName(data.ceo_name);
          setEmail(data.ceo_email);
          setPhone(data.ceo_tel);
        }).catch(err => {
          if (!err.status) {
            alert('서버에 문제가 발생했습니다. 나중에 다시 시도해주세요.');
            props.history.push('/');
          }
        })
    }
    // eslint-disable-next-line
  }, [props.match.params.uid]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Header>
        <Container>
          <HeaderTitle>주문 완료</HeaderTitle>
          <HeaderDescription>주문이 완료되었습니다. 감사합니다.</HeaderDescription>
        </Container>
      </Header>

      <Container>
        <Wrapper>  
          <Section>
            <Title>상품 정보</Title>
            <Content>
              <ShopItem>
                <ShopItemHeader>
                  <ShopItemCell>상품 정보</ShopItemCell>
                  <ShopItemCell>상품 금액</ShopItemCell>
                </ShopItemHeader>
                <ShopItemBody>
                  <ShopItemCell>{shopItem}</ShopItemCell>
                  <ShopItemCell>{price!.toLocaleString()}원</ShopItemCell>
                </ShopItemBody>
              </ShopItem>
            </Content>
          </Section>
          <Section>
            <Title>주문자 정보</Title>
            <SectionContent>
              <Item>
                <p>공급자</p>
                <span>데이트팝</span>
              </Item>
              <Item>
                <p>담당 매니저</p>
                <span>{manager}</span>
              </Item>
              <Item>
                <p>사장님 이름</p>
                <span>{name}</span>
              </Item>
              <Item>
                <p>사장님 이메일</p>
                <span>{email}</span>
              </Item>
              <Item>
                <p>사장님 휴대전화</p>
                <span>{phone}</span>
              </Item>
            </SectionContent>
          </Section>

          <Section>
            <Title>결제 수단</Title>
            <Item>
              <p>일반 결제</p>
              <Radio>
                <input type="radio" defaultChecked={true} value={payMethod} />
                <span></span>
                카드 결제
              </Radio>
            </Item>
          </Section>
        </Wrapper>
      </Container>
    </div>
  );
}

export default PayComplete;
